import Vue from 'vue';

Vue.directive('click-outside', {
  bind: (el, binding, vnode) => {
    const event = (e) => {
      if (!(el === e.target || el.contains(e.target))) {
        vnode.context[binding.expression](e);
      }
    };
    el.clickOutsideEvent = event;
    document.body.addEventListener('click', event);
  },
  unbind: (el) => {
    document.body.removeEventListener('click', el.clickOutsideEvent);
    delete el.clickOutsideEvent;
  }
});
